import { STORAGE_LOCALE } from "@weco/suite-client";

export type SuiteLocale = "en" | "ar";

export function applyDomLocale(locale: SuiteLocale): void {
  document.documentElement.lang = locale;
  document.documentElement.dir = locale === "ar" ? "rtl" : "ltr";
}

/**
 * Read locale preference from localStorage, apply dir/lang to DOM.
 * Returns the stored preference for React state.
 * Call this before ReactDOM.createRoot() so the first paint has correct dir.
 */
export function initSuiteLocaleFromStorage(): SuiteLocale {
  const raw =
    (typeof localStorage !== "undefined" && localStorage.getItem(STORAGE_LOCALE)) || "en";
  const stored: SuiteLocale = raw === "ar" ? "ar" : "en";
  if (typeof document !== "undefined") {
    applyDomLocale(stored);
  }
  return stored;
}
